import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0b498aad&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b498aad')) {
      api.createRecord('0b498aad', component.options)
    } else {
      api.reload('0b498aad', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0b498aad&", function () {
      api.rerender('0b498aad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/reports/debt/components/google/index.vue"
export default component.exports